import { isInWebView } from '@shared/george-go';

export const USE_EMBEDDED_LAYOUT_PARAM_NAME = 'useEmbeddedLayout';

export const shouldUseEmbeddedLayout = (): boolean => {
    const locationSearch = window.location.search;

    const useEmbeddedLayoutParam = new URLSearchParams(locationSearch).get(
        USE_EMBEDDED_LAYOUT_PARAM_NAME,
    );

    return isInWebView() || useEmbeddedLayoutParam === 'true';
};
